/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Pagination, Tag, Modal, Select, Alert, Space } from 'antd';
import { FolderOpenOutlined } from '@ant-design/icons';
import CustomSpin from '../CommonSpin';
import { Content } from 'antd/es/layout/layout';
import { useAuth } from '../../Context';
import { packageClickedIdRequest, packageListRequest } from './Actions';
import { useDispatch, useSelector } from 'react-redux';
import { selectPackageIdList, selectPackageList } from './Selectors';
import { ButtonText, ModalData, ModalHeading, TittleHeader } from '../CommonText';
import { useNavigate } from 'react-router-dom';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

// For more details repeat
const MoreDetails = (props) => (
    <div style={{ marginTop: '10px' }}>
        <strong><ModalData text = {props.heading} color = '#333333'  /></strong> <span>{props.value}</span>
    </div>
);

const AllPackages = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [packageDetails, setPackageDetails] = useState(false);
    const [orgName, setOrgName] = useState('all');

    const {organisationGet, organisationList} = useAuth();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // to check booking coming from promotion
    useEffect(() => {
        organisationGet(4);
        dispatch(packageListRequest('all', 1));
    }, []);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    
    // const packages = useSelector(makeSelectPackages());
    // const requesting = useSelector(makeSelectRequesting());
    // const packageDetailsData = useSelector(makeSelectPackagesDetails());
    // const organisation = useSelector(makeSelectOrganisation());
    

    const packages = useSelector(selectPackageList);
    const requesting = false;
    const packageDetailsData = useSelector(selectPackageIdList);
    const organisation = organisationList;    

    const pageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        dispatch(packageListRequest(orgName, pageNumber));
        // props.dispatch({ type: ALL_PACKAGE_GET_PAGINATION, payload: pageNumber });
    };

    const moreDetails = () => {
        // props.dispatch({ type: PACKAGE_MODAL_DETAILS_GET });
        setPackageDetails(true);
    };

    const handleDetailsCancel = () => {
        setPackageDetails(false);
    };

    const organisationFilter = (value) => {
        dispatch(packageListRequest(value, 1));
        setCurrentPage(1);
        setOrgName(value);
        // props.dispatch({ type: ALL_PACKAGE_GET });
    };

    let modalContent = null;
    if (packageDetailsData !== null) {
        const tests = packageDetailsData && packageDetailsData.tests.map((item) => (
            <div key = {item.id} style={{ marginBottom: '5px' }}>
                <Tag color="blue">{item.name}</Tag>
            </div>
        ));

        modalContent = (
            <div>
                <MoreDetails heading={`${langdata.PackageNameC ? langdata.PackageNameC : 'Package Name:' }`} value={packageDetailsData && packageDetailsData.name} />
                <MoreDetails
                    heading={`${langdata.OrganisationNameC ? langdata.OrganisationNameC : 'Organisation Name:' }`}
                    value={packageDetailsData && packageDetailsData.organisation && packageDetailsData.organisation.name}
                />
                <MoreDetails
                    heading={`${langdata.OrginalPriceC ? langdata.OrginalPriceC : 'Orginalprice:' }`}
                    value={`₹${packageDetailsData && packageDetailsData.originalPrice}`}
                />
                {packageDetailsData && packageDetailsData.isDiscounted === true ? (
                    <MoreDetails
                        heading={`${langdata.DiscountPriceC ? langdata.DiscountPriceC : 'Discount price:'}`}
                        value={`₹${packageDetailsData&& packageDetailsData.discountPrice}`}
                    />
                ) : null}
                <div style={{ marginTop: '10px' }}>
                    <strong><ModalData text = {`${langdata.TestsC ? langdata.TestsC : 'Tests:' }`}  color = '#333333'  /> </strong><span>{tests}</span>
                </div>
            </div>
        );
    }

    let totalPage = 0;
    let packageList = null;
    if (packages !== null) {
        totalPage = packages && packages.total;
        if (totalPage !== 0) {
            packageList = packages && packages.data.map((item) => (
                <Col
                    xs={{ span: 23, offset: 0 }}
                    sm={{ span: 23, offset: 0 }}
                    md={{ span: 7, offset: 0 }}
                    lg={{ span: 7, offset: 0 }}
                    xl={{ span: 6, offset: 0 }}
                    xxl={{ span: 4, offset: 0 }}
                    style={{
                        textAlign: 'center',
                        marginTop: '20px',
                        marginLeft:'2%'
                    }}
                    key={item.id}
                >
                    <div
                        style={{
                            background: '#fff',
                            borderRadius: '4px',
                            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)',
                            height: '250px',
                            // width: '250px',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            // props.dispatch({ type: PACKAGE_DETAILS_POST, payload: item });
                        }}
                    >
                        <div
                            style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '25px', height: '60px' }}
                        >
                            <ModalHeading text = {item.name} />
                        </div>
                        <div style={{ marginTop: '0px', fontWeight: 'bold' }}>
                            <ModalData text = {item.organisation.name} />
                        </div>
                        {item.isDiscounted === true ? (
                            <div style={{ marginTop: '15px' }}>
                                <span style={{ fontSize: '16px', textDecoration: 'line-through' }}>
                  ₹{item.originalPrice}
                                </span>{' '}
                                <span style={{ fontSize: '20px', color: '#185177', fontWeight: 'bolder' }}>
                  ₹{item.discountPrice}
                                </span>
                            </div>
                        ) : (
                            <div style={{ marginTop: '15px' }}>
                                <span style={{ fontSize: '20px', color: '#185177', fontWeight: 'bolder' }}>
                  ₹{item.originalPrice}
                                </span>
                            </div>
                        )}
                        {item.isDiscounted === true ? (
                            <div>
                                <span><ModalData text = {`${langdata.Discount ? langdata.Discount : 'Discount' }`} /> </span>
                                <span>{item.discountPercentage}%</span>
                            </div>
                        ) : null}
                        <div style={{ marginTop: '15px' }}>
                            <Button
                                className="ant-buttonJoin"
                                style={{
                                    backgroundColor: '#f66b04',
                                    color: '#fff',
                                    fontWeight: 'bold',
                                    borderRadius: '16px',
                                    width: '150px',
                                    height: '30px',
                                    borderColor: '#f66b04',
                                }}
                                onClick={() => {
                                    navigate(('/bookcheckup'),{state : {data : item, promotion : false }});
                                }}
                            >
                                <ButtonText text = {`${langdata.BookNow ? langdata.BookNow : 'Book Now' }`} />
                            </Button>{' '}
                        </div>
                        <div style={{ marginTop: '15px' }}>
                            <a
                                onClickCapture={() => {
                                    dispatch(packageClickedIdRequest(item));
                                }}
                                onClick={moreDetails}
                            >
                                {`${langdata.Moredetails ? langdata.Moredetails : 'More details' }`}
                            </a>
                        </div>
                    </div>
                </Col>
            ));
        } else {
            packageList = (
                <Col span={12} offset={6} style={{ marginTop: '25px' }}>
                    <Alert
                        message={`${langdata.NoPackageFound ? langdata.NoPackageFound : 'No Package Found' }`}
                        description={`${langdata.Nopackageforthisorganisationpleasechooseanotherone ? langdata.Nopackageforthisorganisationpleasechooseanotherone : 'No package for this organisation please choose another one' }`}
                        type="info"
                        showIcon
                    />
                </Col>
            );
        }
    }

    const organisationOptions = [];

    organisationOptions.push({
        value : 'all',
        label : 'ALL'
    });
    if (organisation !== null) {
        organisation && organisation.map((item) => (
            organisationOptions.push({
                value : item.id,
                label : item.name
            })
        ));
    }

    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());


    return (
        <Content>
            <div>

                <Row type="flex" justify="center">
                    <Col xs={{ span: 24 }} md={{ span: 24 }}>
                        <Col
                            xs={{ span: 24 }}
                            md={{ span: 24 }}
                            style={{
                                marginTop: '5px',
                                marginBottom: '15px',
                            }}
                        >
                            <Col
                                xs={{ span: 23 }}
                                md={{ span: 23 }}
                                lg={{ span: 23 }}
                                xl={{ span: 23 }}
                                xxl={{ span: 23 }}
                                style={{
                                    marginLeft: '2%',
                                    background: '#fff',
                                    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)',
                                    borderRadius: '4px',
                                }}
                            >
                                <Row>
                                    <Col xs={{ span: 24 }} sm={{span:24}} md={{ span: 14 }} lg={{ span: 10 }} xl={{ span: 10 }} xxl={{ span: 10 }} style={{ textAlign: 'right' }}>
                                        <div
                                            style={{
                                                marginLeft: '1%',
                                                textAlign: 'left',
                                                fontFamily: 'Roboto',
                                                fontSize: '27px',
                                                color: '#1164A6',
                                                paddingLeft: '8px',
                                                margin : '10px',
                                                display: 'flex'
                                            }}
                                        >
                                            <FolderOpenOutlined /> 
                                            <TittleHeader text = {`${langdata.Packages ? langdata.Packages : 'Packages' }`} color='#1164A6'/>
                                        </div>
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{span:24}} md={{ span: 10 }} lg={{ span: 14 }} xl={{ span: 14 }} xxl={{ span: 14 }} style={{display : 'flex', justifyContent : 'flex-end', paddingTop: '12px', paddingBottom: '10px' }}>
                                        {/* <span style={{ margin: '15px' }}> */}
                                        <Select
                                            placeholder={`${langdata.Selectaorganisation ? langdata.Selectaorganisation : 'Select a organisation' }`}
                                            style={{ width: 200, margin:'15px' }}
                                            defaultValue="all"
                                            onChange={organisationFilter}
                                            showSearch
                                            filterOption={filterOption}
                                            options={organisationOptions}
                                            value={orgName}
                                        >
                                            {/* <Select.Option value="all">All</Select.Option>
                                                {organisationOptions} */}
                                        </Select>
                                        
                                        {/* </span> */}
                                        {/* <span > */}
                                        <Space>&nbsp;</Space>

                                        <Button
                                            style={{ margin : '15px'}}
                                            type="primary"
                                            onClick={() => {
                                                navigate('/mycheckups');                                                
                                            }}
                                        >
                                            <ButtonText text = {`${langdata.ViewMyCheckup ? langdata.ViewMyCheckup : 'View My Checkup' }`} />
                                        </Button>
                                        {/* </span> */}
                                    </Col>
                                </Row>
                            </Col>
                        </Col>
                    </Col>
                </Row>
                
                <Row>{packageList}</Row>
                <Row style={{ display : 'flex', justifyContent : 'center', marginTop: '25px', marginBottom: '15px' }}>
                    <Pagination
                        onChange={pageChange}
                        current={currentPage}
                        pageSize={8}
                        hideOnSinglePage
                        total={totalPage}
                    />
                </Row>
                <Modal
                    title={<ModalHeading text = {`${langdata.PackageDetails ? langdata.PackageDetails : 'Package Details' }`} />}
                    open={packageDetails}
                    onCancel={handleDetailsCancel}
                    onOk={handleDetailsCancel}
                    width="40%"
                    footer={null}
                >
                    <Row>{modalContent}</Row>
                </Modal>
                <CustomSpin spinning = {requesting} />
            </div>
        </Content>
    );
};

export default AllPackages;
